import React from 'react';

const LearningSection = () => {
  return (
    <div className="bg-gray-50 rounded-lg p-8 mb-12 shadow-xl">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">What You'll Learn In Cold Email Secrets</h2>
      
      
    </div>
  );
};

export default LearningSection;
